import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react'
import classes from './TimeTableModalTable.module.css'
import { arrowDown, blueArrow, redcross } from '../../../../../../../../assets/icons'
import Popover from '@mui/material/Popover'
import Box from '@mui/material/Box'
import { SelectField } from '../../../../../../../../components'
import { useDispatch, useSelector } from 'react-redux'
import {
  setLoader,
  setOpenAddNewTimeTable,
  setOpenAddTime,
} from '../../../../../../../../redux/globalSlice'
import AddTimeModal from '../../AddTimeModal/AddTimeModal'
import { useGlobal } from '../../../../../../../../shared'
import { urls } from '../../../../../../../../shared/config'
import axios from 'axios'
import { baseURL } from '../../../../../../../../shared/config'
import { toast } from 'react-toastify'

const days = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', '']

const TimeTableModalTable = forwardRef(
  (
    {
      setFormValues,
      formValues,
      typeEnums,
      gradeId,
      sectionObj,
      schoolId,
      customRole,
      userSchoolId,
      day,
      refetch,
      selectedGradeObj
    },
    ref,
  ) => {
    const dispatch = useDispatch()
    const addTime = useSelector((state) => state.global.openAddTime)
    const [selectedRow, setSelectedRow] = useState(null)
    // Fetch data
    const { data: apiData } = useGlobal({
      userUrl: `${urls.TIMETABLE}?school_id=${customRole === 'Admin' ? userSchoolId : ''}&grade_id=${gradeId}&section_id=${sectionObj?.section_id}`,
    })

    const { data: subjectRow } = useGlobal({
      userUrl: `${urls.SUBJECT}?school_id=${customRole === 'Admin' ? userSchoolId : ''}&page=1&limit=100000`,
    })

    const { data: TeacherData } = useGlobal({
      userUrl: `${urls.AVAILAIBLE_TEACHER}?school_id=${
        customRole === 'Admin' ? userSchoolId : ''
      }&day=${day}${
        selectedRow?.time
          ? `&slot_start_timing=${encodeURIComponent(selectedRow.time.split(' – ')[0].trim())}&slot_end_timing=${encodeURIComponent(selectedRow.time.split(' – ')[1].trim())}`
          : ''
      }`,
    })

    const [periods, setPeriods] = useState([])

    const [selectedCell, setSelectedCell] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null)

    const [popoverEntries, setPopoverEntries] = useState([])

    useEffect(() => {
      if (!apiData || !Array.isArray(apiData)) return

      console.log('API Data:', apiData) // Debug log

      const mappedPeriods = apiData.map((item) => {
        // Each item in apiData is already a period entry
        const periodObj = {
          id: item.timetable_id || String(Date.now()), // Use timetable_id as the unique ID
          label: item.slot_name,
          time: `${item.slot_start_timing} – ${item.slot_end_timing}`,
          period_type: item.period_type,
          timetable_id: item.timetable_id, // Store the timetable_id
          schedule: days.reduce((acc, day) => {
            if (day) acc[day] = { subjects: [] }
            return acc
          }, {}),
        }

        // Map slot_data to schedule
        if (item.slot_data && Array.isArray(item.slot_data)) {
          item.slot_data.forEach((dayEntry) => {
            if (dayEntry.day && periodObj.schedule[dayEntry.day]) {
              periodObj.schedule[dayEntry.day].subjects = dayEntry.subjects.map((sub) => ({
                subject: sub.subject_id || '',
                subject_short_form: sub.subject_short_form || '',
                teacher1: sub.teacher_id || '',
                teacher2: sub.second_teacher_id || '',
              }))
            }
          })
        }

        return periodObj
      })

      console.log('Mapped Periods:', mappedPeriods) // Debug log

      if (mappedPeriods.length === 0) {
        // Default empty period
        setPeriods([
          {
            id: '1',
            label: 'PERIOD #1',
            time: '07:30 – 08:30',
            period_type: 'subject',
            timetable_id: null,
            schedule: days.reduce((acc, day) => {
              if (day) acc[day] = { subjects: [] }
              return acc
            }, {}),
          },
        ])
      } else {
        setPeriods(mappedPeriods)
      }
    }, [apiData])

    const handleAddNewPeriod = (newPeriodData) => {
      const { period_name, start_time, end_time, type } = newPeriodData
      const timeString = `${start_time} – ${end_time}`

      const newPeriod = {
        id: String(Date.now()), // UI ID only
        label: period_name || `PERIOD #${periods.length + 1}`,
        time: timeString,
        period_type: type || 'subject',
        timetable_id: null, // New periods have no timetable_id
        schedule: days.reduce((acc, day) => {
          if (day) acc[day] = { subjects: [] }
          return acc
        }, {}),
      }

      setPeriods((prev) => [...prev, newPeriod])
    }
    const handleCellClick = (e, periodId, day) => {
      const selectedPeriod = periods.find((p) => p.id === periodId)
      setSelectedRow(selectedPeriod || null) // Store full row object

      setSelectedCell({ periodId, day })
      const existing = selectedPeriod?.schedule?.[day]?.subjects || []
      setPopoverEntries(existing.length > 0 ? [...existing] : [{}])
      setAnchorEl(e.currentTarget)
    }
    const handleClose = () => {
      setAnchorEl(null)
      setSelectedCell(null)
      // Optional: clear selectedRow when popover closes
      // setSelectedRow(null)
    }

    const isEntryValid = (entry) => {
      // Convert to string safely, but for teacher1 we only care if it exists / is truthy
      const hasSubject = !!entry?.subject && String(entry.subject).trim() !== ''

      // For teacher1: number > 0 or non-empty string is valid
      // empty string, null, undefined, 0 → invalid when subject exists
      const hasTeacher1 = !!entry?.teacher1 && entry.teacher1 !== '' && entry.teacher1 !== 0

      if (hasSubject) {
        return hasTeacher1
      }
      return true
    }

    const open = Boolean(anchorEl)
    const id = open ? 'timetable-popover' : undefined

    const handleAddItemInPopover = () => {
      setPopoverEntries((prev) => [...prev, {}])
    }

    const handlePopoverChange = (index, field, value) => {
      setPopoverEntries((prev) => {
        const updated = prev.map((entry, i) => (i === index ? { ...entry, [field]: value } : entry))

        if (selectedCell) {
          const { periodId, day } = selectedCell
          setPeriods((prevPeriods) =>
            prevPeriods.map((period) =>
              period.id === periodId
                ? {
                    ...period,
                    schedule: {
                      ...period.schedule,
                      [day]: { subjects: updated.filter((e) => e.subject?.trim()) },
                    },
                  }
                : period,
            ),
          )
        }

        return updated
      })
    }

    const handleRemovePeriod = (periodId) => {
      setPeriods((prev) => prev.filter((p) => p.id !== periodId))
      // Clear selectedRow if the removed period was selected
      if (selectedRow?.id === periodId) {
        setSelectedRow(null)
      }
    }

    useImperativeHandle(ref, () => ({
      handleSubmit: async () => {
        dispatch(setLoader(true))
        const validationErrors = []

        periods.forEach((period) => {
          if ((period.period_type || '').toLowerCase() !== 'subject') return

          Object.entries(period.schedule || {}).forEach(([day, entry]) => {
            if (!entry?.subjects?.length) return

            entry.subjects.forEach((sub, subIdx) => {
              const hasSubject = !!sub?.subject && String(sub.subject).trim() !== ''
              const hasTeacher1 = !!sub?.teacher1 && sub.teacher1 !== '' && sub.teacher1 !== 0

              if (hasSubject && !hasTeacher1) {
                validationErrors.push({
                  periodLabel: period.label,
                  time: period.time,
                  day,
                  subjectIndex: subIdx + 1,
                })
              }
            })
          })
        })

        if (validationErrors.length > 0) {
          validationErrors.forEach((err) => {
            toast.error(
              `${err.periodLabel} (${err.time}), ${err.day}: ` +
                `Teacher 1 is required when subject is selected`,
            )
          })

          dispatch(setLoader(false))
          return
        }

        const isUpdate = apiData && apiData.length > 0

        if (isUpdate) {
          // PATCH request - Each period should be its own entry in time_table array
          const timeTable = []

          periods.forEach((period) => {
            const [slot_start_timing, slot_end_timing] = period.time.split(' – ')

            const slotData = days
              .filter((day) => day)
              .map((day) => {
                const entry = period.schedule[day]
                if (!entry?.subjects?.length) return null

                return {
                  day,
                  subjects: entry.subjects.map((sub) => ({
                    subject_id: sub.subject || '',
                    teacher_id: sub.teacher1 || '',
                    second_teacher_id: sub.teacher2 || '',
                  })),
                }
              })
              .filter(Boolean)

            // Check if this period already exists in apiData
            const existingPeriod = apiData.find(
              (item) =>
                item.slot_name === period.label &&
                item.slot_start_timing === slot_start_timing &&
                item.slot_end_timing === slot_end_timing,
            )

            const periodEntry = {
              period: [
                {
                  slot_start_timing: slot_start_timing || '',
                  slot_end_timing: slot_end_timing || '',
                  slot_name: period.label,
                  period_type: period.period_type || formValues.type || 'subject',
                  slot_data: slotData,
                },
              ],
            }

            if (existingPeriod) {
              // Existing period - include timetable_id
              periodEntry.timetable_id = existingPeriod.timetable_id
            }
            // New period - NO timetable_id field at all

            timeTable.push(periodEntry)
          })

          const finalPayload = {
            school_id: userSchoolId || schoolId || '',
            grade_id: gradeId || '',
            section_id: sectionObj?.section_id || '',
            section_map_id: sectionObj?.section_map_id || '',
            time_table: timeTable,
          }

          console.log('PATCH Payload:', JSON.stringify(finalPayload, null, 2))

          try {
            const response = await axios.patch(`${baseURL}${urls.TIMETABLE}`, finalPayload)

            if (response?.data?.status === 201 || response?.data?.status === 200) {
              toast.success('Timetable Updated successfully!')
              dispatch(setOpenAddNewTimeTable(false))
            } else {
              toast.error('Failed to update timetable')
            }
          } catch (error) {
            console.error('Update error:', error)
            toast.error(error.response?.data?.message || 'Error updating timetable')
          } finally {
            refetch()
            dispatch(setLoader(false))
          }
        } else {
          // POST request - Old structure (unchanged)
          const periodArray = periods
            .map((period) => {
              const [slot_start_timing, slot_end_timing] = period.time.split(' – ')

              const slotData = days
                .filter((day) => day)
                .map((day) => {
                  const entry = period.schedule[day]
                  if (!entry?.subjects?.length) return null

                  return {
                    day,
                    subjects: entry.subjects.map((sub) => ({
                      subject_id: sub.subject || '',
                      teacher_id: sub.teacher1 || '',
                      second_teacher_id: sub.teacher2 || '',
                    })),
                  }
                })
                .filter(Boolean)

              return {
                slot_start_timing: slot_start_timing || '',
                slot_end_timing: slot_end_timing || '',
                slot_name: period.label,
                period_type: period.period_type || formValues.type || 'subject',
                slot_data: slotData,
              }
            })
            .filter((p) => p.slot_data?.length > 0)

          const finalPayload = {
            school_id: userSchoolId || schoolId || '',
            grade_id: gradeId || '',
            section_id: sectionObj?.section_id || '',
            section_map_id: sectionObj?.section_map_id || '',
            period: periodArray,
          }

          console.log('POST Payload:', JSON.stringify(finalPayload, null, 2))

          try {
            const response = await axios.post(`${baseURL}${urls.TIMETABLE}`, finalPayload)

            if (response?.data?.status === 201 || response?.data?.status === 200) {
              toast.success('Timetable Added successfully!')
              dispatch(setOpenAddNewTimeTable(false))
            } else {
              toast.error('Failed to add timetable')
            }
          } catch (error) {
            console.error('Save error:', error)
            toast.error(error.response?.data?.message || 'Error saving timetable')
          } finally {
            refetch()
            dispatch(setLoader(false))
          }
        }
      },
    }))
console.log('---selectedGradeObj',selectedGradeObj)

    return (
      <>
        <div className={classes.container}>
          {/* Header */}
          <div className={classes.top}>
            {days.map((value, index) => {
              const isLast = index === days.length - 1
              return (
                <div
                  key={index}
                  className={`${classes.headcell} ${isLast ? classes.finalHeadcell : ''}`}
                >
                  {value}
                </div>
              )
            })}
          </div>

          <div className={classes.middle}>
            <div className={classes.firstColumn}>
              {periods.map((item) => (
                <div key={item.id} className={classes.boxitem}>
                  <span className={classes.item}>{item.label}</span>
                  <span className={classes.secItem}>{item.time}</span>
                </div>
              ))}
            </div>

            <div className={classes.gridBody}>
              {periods.map((period) => (
                <div key={period.id} className={classes.periodRow}>
                  {days.slice(1, -1).map((day) => {
                    const entry = period.schedule?.[day]
                    const isSelected =
                      selectedCell?.periodId === period.id && selectedCell?.day === day

                    // Check if period is editable (subject OR freeTime)
                    const periodType = (period.period_type || '').toLowerCase()
                    const isEditablePeriod = periodType === 'subject' || periodType === 'freetime'

                    let cellContent = null

                    if (periodType === 'subject' || periodType === 'freetime') {
                      // Editable periods - show subjects or placeholder
                      const shortSubjects =
                        entry?.subjects
                          ?.map((s) => {
                            const subj = subjectRow?.find((sub) => sub.subject_id === s.subject)
                            return (
                              subj?.subject_short_form ||
                              (s.subject ? s.subject.substring(0, 3).toUpperCase() : '—')
                            )
                          })
                          .filter(Boolean)
                          .join(', ') || ''

                      cellContent = shortSubjects ? (
                        <span className={classes.content}>{shortSubjects}</span>
                      ) : (
                        <span className={classes.placeholder}>Select</span>
                      )
                    } else {
                      // Non-editable periods (recess, etc.) - show period type
                      const displayType = period.period_type
                        ? period.period_type.charAt(0).toUpperCase() +
                          period.period_type.slice(1).toLowerCase()
                        : '—'

                      cellContent = <span className={classes.nonSubject}>{displayType}</span>
                    }

                    return (
                      <div
                        key={day}
                        className={`
              ${classes.whitebox} 
              ${isSelected ? classes.selected : ''} 
              ${!isEditablePeriod ? classes.nonClickable : ''}
            `}
                        onClick={
                          isEditablePeriod ? (e) => handleCellClick(e, period.id, day) : undefined
                        }
                        role={isEditablePeriod ? 'button' : undefined}
                        tabIndex={isEditablePeriod ? 0 : undefined}
                      >
                        {cellContent}

                        {/* Show dropdown arrow for editable periods */}
                        {isEditablePeriod && (
                          <img
                            src={isSelected ? blueArrow : arrowDown}
                            alt="dropdown"
                            className={classes.icon}
                          />
                        )}
                      </div>
                    )
                  })}
                </div>
              ))}
            </div>

            <div className={classes.finalColumn}>
              {periods.map((item) => (
                <div
                  onClick={() => handleRemovePeriod(item.id)}
                  key={item.id}
                  className={classes.icobox}
                >
                  <img src={redcross} alt="remove" className={classes.ico} />
                </div>
              ))}
            </div>
          </div>

          <button onClick={() => dispatch(setOpenAddTime(true))} className={classes.addNew}>
            Add New +
          </button>

          {/* Popover with correct mapping */}
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            slotProps={{
              paper: {
                sx: {
                  display: 'flex',
                  width: 300,
                  padding: '12px',
                  flexDirection: 'column',
                  gap: '12px',
                  borderRadius: '6px',
                  background: 'var(--White, #FFF)',
                  boxShadow:
                    '0 0 0 1px rgba(152, 161, 178, 0.10), 0 15px 35px -5px rgba(17, 24, 38, 0.15), 0 5px 15px 0 rgba(0, 0, 0, 0.08)',
                  border: 'none',
                  overflow: 'visible',
                },
              },
            }}
          >
            {popoverEntries.map((entry, index) => (
              <Box key={index} sx={{ borderBottom: '1px solid #eee', pb: 2 }}>
                {/* Subject: show name, store ID */}
                <SelectField
                  placeholder=""
                  options={
                    subjectRow?.map((sub) => ({
                      value: sub.subject_id, // store ID
                      label: sub.subject_name, // show full name
                    })) || []
                  }
                  onChange={(selected) =>
                    handlePopoverChange(index, 'subject', selected?.value || selected)
                  }
                  value={entry.subject || ''} // ID
                  subLabel={`Subject ${index + 1} :`}
                  filter
                />

                {/* Teacher 1: show name, store ID */}
                <SelectField
                  placeholder=""
                  options={
                    TeacherData?.map((t) => ({
                      value: t.employee_id, // store ID
                      label: t.employee_name, // show full name
                    })) || []
                  }
                  onChange={(selected) =>
                    handlePopoverChange(index, 'teacher1', selected?.value || selected)
                  }
                  value={entry.teacher1 || ''} // ID
                  subLabel={`Teacher 1 :`}
                  filter
                />

                {/* Teacher 2: show name, store ID */}
                <SelectField
                  placeholder=""
                  options={
                    TeacherData?.map((t) => ({
                      value: t.employee_id,
                      label: t.employee_name,
                    })) || []
                  }
                  onChange={(selected) =>
                    handlePopoverChange(index, 'teacher2', selected?.value || selected || '')
                  }
                  value={entry.teacher2 || ''} // ID
                  subLabel={`Teacher 2 :`}
                  filter
                />
              </Box>
            ))}

            <button
              onClick={() => setPopoverEntries((prev) => [...prev, {}])}
              className={classes.addNew}
              style={{ marginTop: '12px', width: '100%' }}
              disabled={
                popoverEntries.length > 0 &&
                !isEntryValid(popoverEntries[popoverEntries.length - 1])
              }
            >
              Add Subject +
            </button>
          </Popover>
        </div>

        {addTime && (
          <AddTimeModal
            setFormValues={setFormValues}
            formValues={formValues}
            onAddPeriod={handleAddNewPeriod}
            typeEnums={typeEnums}
          />
        )}
      </>
    )
  },
)

export default TimeTableModalTable

// <div className={classes.gridBody}>
//             {periods.map((period) => (
//               <div key={period.id} className={classes.periodRow}>
//                 {days.slice(1, -1).map((day) => {
//                   const entry = period.schedule?.[day]
//                   const isSelected =
//                     selectedCell?.periodId === period.id && selectedCell?.day === day
//                   const isSubjectPeriod = (period.period_type || '').toLowerCase() === 'subject'
//                   let cellContent = null
//                   if (isSubjectPeriod) {
//                     const shortSubjects =
//                       entry?.subjects
//                         ?.map((s) => {
//                           const subj = subjectRow?.find((sub) => sub.subject_id === s.subject)
//                           return (
//                             subj?.subject_short_form ||
//                             (s.subject ? s.subject.substring(0, 3).toUpperCase() : '—')
//                           )
//                         })
//                         .filter(Boolean)
//                         .join(', ') || ''

//                     cellContent = shortSubjects ? (
//                       <span className={classes.content}>{shortSubjects}</span>
//                     ) : (
//                       <span className={classes.placeholder}>Select</span>
//                     )
//                   } else {
//                     // Non-subject: show period type (e.g. "Break", "Lunch", "Assembly")
//                     const displayType = period.period_type
//                       ? period.period_type.charAt(0).toUpperCase() +
//                         period.period_type.slice(1).toLowerCase()
//                       : '—'

//                     cellContent = <span className={classes.nonSubject}>{displayType}</span>
//                   }

//                   return (
//                     <div
//                       key={day}
//                       className={`
//             ${classes.whitebox}
//             ${isSelected ? classes.selected : ''}
//             ${!isSubjectPeriod ? classes.nonClickable : ''}
//           `}
//                       onClick={
//                         isSubjectPeriod ? (e) => handleCellClick(e, period.id, day) : undefined
//                       }
//                       role={isSubjectPeriod ? 'button' : undefined}
//                       tabIndex={isSubjectPeriod ? 0 : undefined}
//                     >
//                       {cellContent}

//                       {/* Only show dropdown arrow for subject periods */}
//                       {isSubjectPeriod && (
//                         <img
//                           src={isSelected ? blueArrow : arrowDown}
//                           alt="dropdown"
//                           className={classes.icon}
//                         />
//                       )}
//                     </div>
//                   )
//                 })}
//               </div>
//             ))}
//           </div>
